var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"title":_vm.$t('blocked.pageTitle'),"description":_vm.$t('blocked.pageSubtitle'),"to":{ name: _vm.RouteName.Moderation }}},[_c('TermsAndPhrases')],1)}
var staticRenderFns = []

export { render, staticRenderFns }